import { camelizeKeys } from 'humps';
import { ihubGet, urlWithParams } from '@namespace/helpers';
import { IApiResponse, IError, PlatformType } from '../../../types';

interface IGetLaunchGameUrlParams {
  gameId: string | number;
  demo: boolean;
  locale: string;
  lobbyUrl: string;
  depositUrl: string;
  platform: PlatformType;
  userId?: string;
}

interface ILaunchGameResponseData {
  url?: string;
  directGameUrl?: string;
  launchUrl?: string;
  content?: string | null;
}

export const getLaunchGameUrl = ({
  gameId,
  demo,
  locale,
  lobbyUrl,
  depositUrl,
  platform,
  userId
}: IGetLaunchGameUrlParams): Promise<ILaunchGameResponseData> => {
  const request = {
    is_demo: `${Number(Boolean(demo))}`,
    locale,
    lobby_url: lobbyUrl,
    deposit_url: depositUrl,
    platform,
    ...(userId && { user_id: userId })
  };
  return ihubGet<IApiResponse<ILaunchGameResponseData>>(
    urlWithParams(`/service/ihub-sw/api/launcher/${gameId}`, request)
  )
    .then((response) =>
      camelizeKeys<IApiResponse<ILaunchGameResponseData>>(response)
    )
    .then((response): ILaunchGameResponseData => {
      const { url, directGameUrl } = response?.data || {};
      const launchUrl = directGameUrl || url;
      if (response.status === 'error') {
        throw new Error();
      }
      return { launchUrl, ...response.data };
    })
    .catch((e: IError) => {
      throw Object.assign(new Error(e?.errorCode), {
        launchGameErrorCode: e.errorCode
      });
    });
};
